import ErrorPage from "../pages/ErrorPage";

export function meta() {
  return [
    { title: "ePaper" },
    { name: "robots", content: "noindex, nofollow" },
  ];
}

export default function ErrorRoute() {
  return <ErrorPage />;
}
